import { render, staticRenderFns } from "./AdyenTermsAndConditions.vue?vue&type=template&id=cf6fa7a6&"
import script from "./AdyenTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./AdyenTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./AdyenTermsAndConditions.vue?vue&type=style&index=0&id=cf6fa7a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports